module.exports = __webpack_public_path__ + "static/media/innovacare.0b7c7d49.svg";